<template>
  <div v-bind:class="{'wait': deletionStarted }" v-if="current" class="row" id="news-detail-panel">
    <confirmModal v-if="showConfirmModal" message="Vous êtes sûr de vouloir supprimer cet article ?" @confirm="deletePage" @closeMessage="showConfirmModal = false"></confirmModal>
    <messageModal v-if="showDeleteMessage" message="votre article a été supprimée" @closeMessage="goToPageList"></messageModal>
        <div class="detailed-news-panel">
            <div class="detailed-news-panel-title">
                <div class="row columns">
                    <div class="medium-5 columns">
                        <p v-html="current.title"></p>
                        <p>
                            <span>
                                <i class="fa fa-calendar" aria-hidden="true"></i>le {{current.created | formatDate }}
                            </span>
                        </p>
                    </div>
                    <div class="medium-4 columns">
                        <div class="row columns">
                            <div class="medium-8 large-centered columns">
                              <img class="league-icon" :src="current.featured_club.icon_path" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="medium-3 columns">
                        <div class="detailed-news-actions">
                            <div v-if="currentUser !== null">
                              <router-link v-if="currentUser.is_superuser" :to="{ name: 'pageEdit', params: { id: current.id.toString() }}" ><button class="full-width"><i class="fa fa-pencil" aria-hidden="true"></i>Modifier</button></router-link>
                              <button v-if="currentUser.is_superuser" @click="showConfirmModal = true" class="full-width alert"><i class="fa fa-trash-o" aria-hidden="true"></i>Supprimer</button>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
            <div v-html="current.content" class="panel-content">
            </div>
        </div>
        <commentPanel :entity_type="pageContentType.id" :entity_id="id"></commentPanel>
    </div>
  <div v-else class="row">
    <spinner></spinner>
  </div>
</template>

<script>
import store from '../../store/index.js'
import spinner from '../common/spinner.vue'
import confirmModal from '../common/confirm-modal.vue'
import messageModal from '../common/message-modal.vue'
import formatDate from '../../common/filters.js'
import { mapGetters } from 'vuex'
import page from '../../api/page.api'
import commentPanel from '../common/comment-panel.vue'

export default {
  name: 'pageDetail',
  props: {
    'id': String
  },
  components: {
    spinner,
    confirmModal,
    messageModal,
    commentPanel
  },
  data () {
    return {
      comment: '',
      showConfirmModal: false,
      showDeleteMessage: false,
      deletionStarted: false
    }
  },
  computed:
  {
    ...mapGetters([
      'detailedPage',
      'currentUser',
      'isLogged'
    ]),
    current: function () {
      return store.getters.detailedPage
    },
    pageContentType: function () {
      return store.getters.getContent('bbc_content', 'content')
    }
  },
  filters: {
    formatDate
  },
  methods: {
    deletePage () {
      this.showConfirmModal = false
      this.deletionStarted = true
      page.api.deletePage(this.detailedPage)
      .then(
      response => {
        this.showDeleteMessage = true
        this.deletionStarted = false
      },
      error => {
        console.log('impossible to delete Page ' + this.detailedPage.id)
        console.log(error)
      })
    },
    refresh () {
      store.dispatch('getDetailedArticle', this.id.toString())
    },
    goToPageList () {
      this.$router.push({name: 'PageList'})
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getContentType')
    store.dispatch('getDetailedPage', this.id.toString())
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detailed-news-panel  {
    background-color: rgba(255,255,255,0.9);

    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    padding: 0rem;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
}

.detailed-news-panel-title {
    width: 100%;
    text-align: left;
    font-weight: 300;
    font-size: 2rem;
    padding: 1.4rem 1.4rem 0rem 1.3rem;
}

.comment-separator {
    margin-top: 0.5rem;
}

.comment-content {
    font-size:1rem;
}

.detailed-news-panel-title p:nth-of-type(2){
    font-size: 1rem;
}

.detailed-news-panel-title p:nth-of-type(3){
    font-size: 1rem;
}
a.news-navigation {
  font-size: 1.2rem;
    font-weight: 300;
}

a.news-navigation:nth-of-type(2){
    float:right;
}


.comment-form textarea {
    height: 100px;
}

.detailed-news-actions {
    float:right;
    display: inline-block;
    font-size: 1rem;
    font-weight: 400
}

.detailed-news-actions button {
    display: block;
    margin: 0.5rem
}
.wait {
  cursor: wait;
}
.league-icon {
    width: 100px;
    height: 100px;
}
</style>



// WEBPACK FOOTER //
// page-detail.vue?a7447640